import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import { ModalContextProvider } from '@billy/design-system'
import { QueryClientProvider } from 'react-query'

import { GlobalUser } from '@features/globalUser'
import {
  UserOrganizationContextProvider,
  UserOrganizationSettingsContextProvider,
} from '@modules-deprecated/app/organization'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'

import { queryClient } from '../../config/queryClient'
import { EmberNavigate, EmberRouterContextProvider } from '../../contexts/emberRouterContext'
import { ThemeProvider } from '../../contexts/themeProvider'
import { HistoryRouter } from '../../utils/HistoryRouter'

const MODULE_NAME = 'global-user-module'

class GlobalUserWebComponent extends DOMModel {
  @byAttrVal organizationid: string
  @registerEvent('navigate') navigate: Function
}

interface GlobalUserModuleProps {
  organizationid: string
  onNavigate: EmberNavigate
}

const GlobalUserModule = ({ organizationid, onNavigate }: GlobalUserModuleProps) => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <HistoryRouter>
        <UserOrganizationContextProvider organizationId={organizationid}>
          <UserOrganizationSettingsContextProvider organizationId={organizationid}>
            <CurrentUserContextProvider>
              <EmberRouterContextProvider onNavigate={onNavigate}>
                <ModalContextProvider>
                  <GlobalUser />
                </ModalContextProvider>
              </EmberRouterContextProvider>
            </CurrentUserContextProvider>
          </UserOrganizationSettingsContextProvider>
        </UserOrganizationContextProvider>
      </HistoryRouter>
    </ThemeProvider>
  </QueryClientProvider>
)

const GlobalUserElement = createCustomElement(GlobalUserModule, GlobalUserWebComponent, 'element')

customElements.get(MODULE_NAME) || customElements.define(MODULE_NAME, GlobalUserElement)
